<div class="freedom-pay">
  @if (loading) {
    <div class="freedom-pay__loading">{{ 'freedompay.processing' | translate: { fgbdefault: 'Processing…' } }}</div>
  }

  <!-- FreedomPay HPC iframe is injected here (only once it exists); postMessage resizes it. -->
  @if (iframeHtml) {
    <div #paymentFrame class="freedom-pay__frame" [innerHTML]="iframeHtml"></div>
  }
</div>
